module.exports = __webpack_public_path__ + "static/media/31JFA7.030118e6.jpg";